import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Tours from '../components/Tours';
import TourPreview from './tours/Preview';
import Header from './layout/Header';
import Map from './Map';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import * as TourActions from '../actions/tour';
import Translate from './layout/Translate';
import Facebook from './popups/Facebook';
import Helmet from "react-helmet";



class Collection extends Component {

    componentDidMount() {

        this.props.toursActions.setMapHeight(ReactDOM.findDOMNode(this.refs.main).clientHeight);
        this.props.toursActions.fetchPromo(this.props.params.param_id);

    }

    componentWillMount() {

        console.info('PROMO OBJECT');
        console.info(this.props.promo);

        if (this.props.promo.config && this.props.promo.config.map) {
            this.props.toursActions.setMapConfig({
                center: {lat: this.props.promo.config.map.center.latitude, lng: this.props.promo.config.map.center.longitude},
                zoom: this.props.promo.config.map.zoom,
                active: false,
                fixed: true,
                type: 'ROADMAP',
                showBoundedObjects: true,
                boundedObjectsWithoutFilters: true,
                destination: true
            });
        } else {
            this.props.toursActions.setMapConfig({
                active: false,
                fixed: true,
                type: 'ROADMAP',
                showBoundedObjects: true,
                boundedObjectsWithoutFilters: true,
                destination: true
            });
        }



    }

    
    componentWillUpdate() {
        
    }

    componentWillUnmount() {

        this.props.toursActions.setMapConfig({
            showBoundedObjects: false,
            boundedObjectsWithoutFilters: false,
            fixed: false,
            destination: false
        });

    }




    selectTour() {
        this.props.toursActions.selectTour(this.props.list[this.props.activeTour])
    }
    selectMapPhoto(photo, i) {
        this.props.toursActions.selectMapPhoto(photo, i);
    }


    selectLandmark(landmark) {
        this.props.toursActions.selectLandmark(landmark);
    }

    moreObjects(params) {
        this.props.toursActions.moreObjects(params);
    }

    toggleToursPhotos() {
        this.props.toursActions.toggleViewPhoto();
    }

    render () {
        const { list, boundedObjects, map, seo } = this.props;

        let promo = this.props.promo;
        let { tours, landmarks, photos } = boundedObjects,
            hasPhotos = boundedObjects.photos && boundedObjects.photos.list && !!boundedObjects.photos.list.length && map.show_photos,
            hasLandmarks = boundedObjects.landmarks && boundedObjects.landmarks.list && !!boundedObjects.landmarks.list.length && map.show_landmarks,
            re = /<[^>]+>/g,
            description = (promo.text)?promo.text.replace(re, ''):"";

        description = description.substr(0, 205);

        let lastSpace = description.lastIndexOf(" ");
        if( lastSpace > 0 && description.length > 200) {
            description = description.substr(0, lastSpace);
        }



        let meta = [
            {"name": "description", "content": (seo.description)?seo.description:description}
        ];

        return (

            <section className="section " ref="main">

                <Helmet
                    title={(seo.title)?seo.title:promo.title}
                    meta={meta}
                />
                <div className="section__content">
                    <Header />
                    <div className="tours">

                        
                        <div className="container promo container_tours">
                            {!seo.h1 &&
                                <h1>{promo.title}</h1>
                            }
                            {seo.h1 &&
                                <h1>{seo.h1}</h1>
                            }



                            <div className="container__description">
                                <div dangerouslySetInnerHTML={{__html:promo.text}}></div>
                            </div>

                            {promo.tours &&
                                <div className="navigate">
                                        <div className="navigate__title">
                                            <Translate slug="destination__tours" /> <span className="navigate__count">{promo.tours.length}</span>
                                            <div className={"navigate__show-photos " + ((this.props.showToursPhotos)?'navigate__show-photos_active':'')} onClick={this.toggleToursPhotos.bind(this)}>
                                                {!(this.props.showToursPhotos) &&
                                                <Translate slug="navigate__show-photo" />
                                                }
                                                {(this.props.showToursPhotos) &&
                                                <Translate slug="navigate__hide-photo" />
                                                }
                                            </div>
                                        </div>
                                        {promo.tours.map((tour, i) =>
                                        <div>
                                            {tour &&
                                                <TourPreview key={'tour' + (tour)?tour.id:''} showPhotos={this.props.showToursPhotos} lang={this.props.lang} tour={tour} nextTour={this.props.toursActions.nextTour} selectTour={this.props.toursActions.selectTour} />
                                            }
                                        </div>
                                        )}
                                </div>
                            }


                            <div className="container__description">

                            </div>
                        </div>
                    </div>
                </div>

                <Facebook />
                <div className="footer__registration">
                    <Translate
                        slug="main__registration"/>
                </div>

            </section>
        );
    }
}


Collection.need = [
    {
        action: toursActions.fetchTours
    },
    {
        action: toursActions.fetchPromo
    }
];



function mapStateToProps(state) {
    return {
        mapHeight: state.tours.mapHeight,
        list: state.tours.list,
        promo: state.tours.promo,
        boundedObjects: state.tours.boundedObjects,
        map: state.tours.map,
        activeTour: state.tours.activeTour,
        showToursPhotos: state.tours.showToursPhotos,
        lang: state.user.lang,
        seo: state.user.seo
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Collection)





// WEBPACK FOOTER //
// ./src/common/components/Collection.js